module.exports = __webpack_public_path__ + "img/burrito.bba42d97.svg";